import React from 'react';
import { Error } from '@pattern-library/result';
import PropTypes from 'prop-types';

const propTypes = {
    loginUrl: PropTypes.string.isRequired,
    title: PropTypes.string,
    errorMessage: PropTypes.string
};

function SsoOutError(props) {
    const { title, errorMessage, loginUrl } = props;

    return (
        <Error
            button={
                <a className="asc-btn" href={loginUrl}>
                    Log In
                </a>
            }
            title={title}
            message={errorMessage}
        />
    );
}

SsoOutError.propTypes = propTypes;
export default SsoOutError;
